"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "visso": {
    "39085498": [{
      "hkey": "b62c13b2",
      "slug": "visso",
      "name": "Visso",
      "primary": true,
      "skipSearch": false
    }],
    "chiusita": [{
      "hkey": "b62c13b2",
      "slug": "visso",
      "name": "Visso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9c0e9e6d": [{
      "hkey": "b62c13b2",
      "slug": "visso",
      "name": "Visso",
      "primary": true,
      "skipSearch": false
    }],
    "molini": [{
      "hkey": "b62c13b2",
      "slug": "visso",
      "name": "Visso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "54bea25c": [{
      "hkey": "a61ad3d6",
      "slug": "borgo-sant-antonio",
      "name": "Borgo Sant'Antonio",
      "primary": true,
      "skipSearch": false
    }],
    "villa-sant-antonio": [{
      "hkey": "a61ad3d6",
      "slug": "borgo-sant-antonio",
      "name": "Borgo Sant'Antonio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;